import{n as i,r as t,y as e}from"../../493beda6.js";customElements.define("cai-icon-info",class extends i{static get styles(){return t`
      :host {
        display: inline-block;
        width: var(--cai-icon-width, 16px);
        height: var(--cai-icon-height, 16px);
      }

      svg {
        width: 100%;
        height: 100%;
        fill: var(--cai-icon-fill, currentColor);
      }

      path {
      }
    `}render(){return e`<svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25.099 25.1"
      preserveAspectRatio="xMidYMid meet"
      part="svg"
    >
      <g data-name="Fill 2" fill="#fff" stroke-miterlimit="10">
        <path
          d="M10.31 4.199 7.049 3.022l-.611 3.416-3.416.611 1.177 3.261-2.65 2.239 2.648 2.238-1.175 3.262 3.415.611.612 3.416 3.264-1.176 2.236 2.649 2.238-2.65 3.262 1.177.609-3.415 3.416-.61-1.177-3.264 2.652-2.238-2.651-2.239 1.177-3.261-3.416-.61-.61-3.416-3.262 1.176-2.238-2.65Z"
        />
        <path
          d="m12.548 1.549-2.238 2.65-3.263-1.177-.61 3.416-3.415.609 1.177 3.263-2.65 2.239 2.648 2.238-1.175 3.263 3.415.611.609 3.415 3.264-1.175 2.238 2.65 2.238-2.65 3.264 1.175.61-3.415 3.415-.61-1.177-3.264 2.651-2.238-2.65-2.24 1.176-3.261-3.416-.61-.609-3.415-3.263 1.176-2.24-2.65m0-1.55 2.555 3.023 3.724-1.342.695 3.896 3.897.696-1.343 3.723 3.024 2.554-3.024 2.553 1.343 3.725-3.897.696-.695 3.896-3.725-1.342-2.553 3.023-2.553-3.023-3.725 1.342-.696-3.896-3.895-.697 1.342-3.724L0 12.55l3.022-2.554-1.344-3.724 3.898-.695.695-3.898 3.724 1.344L12.548 0Z"
          fill="rgba(0,0,0,0.3)"
        />
      </g>
      <path
        data-name="Fill 4"
        d="M13.799 18.549h-2.5v-7.2h2.5v7.2Zm0-9.6h-2.5v-2.4h2.5v2.4Z"
        fill="#2c2c2c"
      />
    </svg>`}});
